import React, { useState, useEffect, useMemo, forwardRef, useRef } from "react";
import styled from "styled-components";
import {
  Button,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Checkbox,
  Drawer,
} from "@material-ui/core";
import { useTable, useRowSelect, useSortBy, useFilters } from "react-table";
import urlLinks from "../../UrlLinks";
import Axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import NoRecord from "./noRecord.svg";
import styles from "./index.module.scss";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Link, useHistory } from "react-router-dom";
import AddIcon from "../Assets/Add.svg";
import { AppData } from "../../context/context";
import { useContext } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { AuthContext } from "../../services/AuthProvider";
import TableModal from "../../Utils/dialogs/TableModal";
import SearchBar from "../../Utils/functions/SearchBar";
import ActionsDropdown from "../../Utils/functions/ActionsDropdown";
import filterIcon from "../ProjectConfig/filterIcon.svg";
import filterIconMarked from "../ProjectConfig/filterIconMarked.svg";
import FilterDrawer from "./components/FilterDrawer";
import uploadIcon from "./uploadIcon.svg";
import ExportButton from "../../Utils/functions/ExportButton";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../store/actions/index";

const Styles = styled.div`
  padding: 1rem;
  font-family: "Inter";
  .tableContainer {
    overflow-x: scroll;
    border: 1px solid #cfcfcf;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: 94%;
    position: absolute;
    max-height: 74vh;
  }
  .tableContainer::-webkit-scrollbar {
    width: 0.75em;
  }
  .tableContainer::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  .tableContainer::-webkit-scrollbar-thumb {
    background-color: darkgrey;
  }
  table {
    border-spacing: 0;
    width: 100%;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th {
      :last-child {
        border-left: 0;
      }
      background-color: #1c4980 !important;
      color: #ffffff;
    }
    th,
    td {
      padding: 20px 15px;
    }
    td {
      margin: 0;
      background-color: white;
      nth-last-child(2) {
        border-right: 0;
      }
      :last-child {
        border-right: 0;
      }
      input {
        font-size: 1rem;
        padding: 0;
        margin: 0;
        border: 0;
      }
    }
  }
  .pagination {
    padding: 0.5rem;
  }
`;

const useStyles = makeStyles((theme) => ({
  actionButton: {
    "& .MuiSelect-selectMenu": {
      border: "1px solid #1C4980",
      color: "#1C4980",
    },
    "& .MuiSelect-icon": {
      top: "calc(50% - 10px)",
    },
    "& .MuiSelect-iconOutlined": {
      right: 0,
      color: "#1C4980",
    },
    "& .css-i4bv87-MuiSvgIcon-root": {
      fontSize: "20px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1C4980",
    },
  },
  tabs: {
    "& .MuiTabs-flexContainer": {
      flexWrap: "wrap",
    },
  },
}));

const MpaConfig = (props) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const { showToast } = useContext(AuthContext);
  const { mpaFormMode, setMpaFormMode, userAction } = useContext(AppData);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [actions, setActions] = useState(0);
  const [openMpaModal, setOpenMpaModal] = useState(false);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [mpaId, setMpaId] = useState(null);
  const [searchBy, setSearchBy] = useState("");
  const [searchError, setSearchError] = useState(false);
  const [uploadAction, setUploadAction] = useState(-1);
  const [filters, setFilters] = useState({
    searchBy: "",
    mpaName: "",
    isCompany: "",
    companyType: "",
    location: "",
    spocEmailId: "",
    phoneNumber: "",
    mpaCode: "",
  });
  const [searchByAuto, setSearchByAuto] = useState("");
  const [filterUrl, setFilterUrl] = useState("");
  const history = useHistory();
  const [isFilterDrawer, setIsFilterDrawer] = useState(false);
  const [tabValue, setTabValue] = useState("Approval in progress");
  const [selectedMpaIds, setSelectedMpaIds] = useState("");
  const tabsData = useMemo(
    () => [
      { label: "Approval in progress", value: "Approval in progress" },
      { label: "Verified", value: "Verified" },
      { label: "Document Sign", value: "Document Sign" },
      { label: "Inactive", value: "Inactive" },
      { label: "Failed", value: "Failed" },
    ],
    []
  );

  const [allRecordLoading, setAllRecordLoading] = useState(false);
  const dispatch = useDispatch();
  const { setAllRecord } = bindActionCreators(actionCreators, dispatch);

  const makeAllRecordData = (response) => {
    let extractedData = [];
    response.map((el) => {
      extractedData.push({
        mpaCode: el.mpaCode || "",
        mpa_name: el.mpa_name || "",
        companyType: el.companyType || "",
        pan: el.pan || "",
        gst: el.gst || "",
        phone_number: el.phone_number || "",
        spoc_name: el.spoc_name || "",
        spoc_email_id: el.spoc_email_id || "",
        designation: el.designation || "",
        location: el.location || "",
      });
      return true;
    });
    return extractedData;
  };

  useEffect(() => {
    ApplyFilters();
  }, [searchByAuto]);

  const ApplyFilters = () => {
    setFilterUrl(filterUrl);
    setFilters((prev) => ({ ...prev, searchBy: searchBy }));
    setCurrentPage(1);
    getPaymentListing(perPage, currentPage);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    // createAllRecordExcel();
    setAllRecord([]);
    setAllRecordLoading(false);
  }, [tabValue]);

  const a11yProps = (index) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });

  const actionList = [
    {
      id: "moreDetails",
      name: "More Details",
    },
  ];

  const IndeterminateCheckbox = forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = useRef();
      const resolvedRef = ref || defaultRef;

      useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate]);

      return (
        <React.Fragment>
          <Checkbox ref={resolvedRef} {...rest} />
        </React.Fragment>
      );
    }
  );

  const handleAggrementUpload = (userId) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,.pdf';
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      try {
        setLoading(true);
        const response = await fetch(
          `${urlLinks.baseUrl}user/uploadUserDocuments?document_type=Client_Agreement&file_name=file&user_id=${userId}`,
          {
            method: 'POST',
            body: formData,
          }
        );

        if (response.ok) {
          showToast('Agreement uploaded successfully', 'success');
          getPaymentListing(perPage, currentPage);
        } else {
          showToast('Failed to upload agreement', 'error');
        }
      } catch (error) {
        showToast('Error uploading agreement', 'error');
      } finally {
        setLoading(false);
      }
    };
    input.click();
  };

  const columnsOkayGo = useMemo(() => {
    const baseColumns = [
      {
        Header: "Company Name",
        accessor: "mpa_name",
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Company Type",
        accessor: "companyType",
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "MPA Code",
        accessor: "mpaCode",
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "PAN No",
        accessor: "pan",
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "GST No",
        accessor: "gst",
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Phone No",
        accessor: "phone_number",
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Signatory Name",
        accessor: "spoc_name",
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Email ID",
        accessor: "spoc_email_id",
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Designation",
        accessor: "designation",
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Location",
        accessor: "location",
        defaultCanFilter: false,
        defaultCanSort: false,
      },
      {
        Header: "Aadhar Card",
        accessor: "aadharCard",
        Cell: (row) => {
          return row.row.original.aadharCard ? (
            <div>
              <Link
                to={{ pathname: row.row.original.aadharCard }}
                target="_blank"
                className="nameLink"
              >
                View Image
              </Link>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: "PAN No.",
        accessor: "panCard",
        Cell: (row) => {
          return row.row.original.panCard ? (
            <div>
              <Link
              style={{whiteSpace:"nowrap"}}
                to={{ pathname: row.row.original.panCard }}
                target="_blank"
                className="nameLink"
              >
                View Image
              </Link>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: "GST No.",
        accessor: "gstCard",
        Cell: (row) => {
          return row.row.original.gstCard ? (
            <div>
              <Link
                to={{ pathname: row.row.original.gstCard }}
                target="_blank"
                className="nameLink"
                style={{whiteSpace:"nowrap"}}
              >
                View Image
              </Link>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: " ",
        Cell: (row) => {
          return (
            <button
              onClick={() =>
                handleActions("moreDetails", row.row.original.mpa_id)
              }
              className={styles.moreDetailsButton}
            >
              More Details
            </button>
          );
        },
        defaultCanFilter: false,
        defaultCanSort: false,
      },
    ].filter(Boolean);

    if (tabValue === "Document Sign") {
      baseColumns.splice(baseColumns.length - 1, 0, {
        Header: "Agreement",
        accessor: "client_agreement",
        Cell: (row) => {
          return row.row.original.client_agreement ? (
            <div>
              <Link
                to={{ pathname: row.row.original.client_agreement }}
                target="_blank"
                className="nameLink"
              >
                Download
              </Link>
            </div>
          ) : (
            <div
              className={styles.UploadAggrementBtn}
              onClick={() => handleAggrementUpload(row.row.original.user_id)}
            >
              <img src={uploadIcon} alt="upload" />
              Upload
            </div>
          );
        },
      });
    }
    if (!!userAction.edit && tabValue !== "Failed") {
      baseColumns.unshift({
        id: "selection",
        Header: ({ getToggleAllRowsSelectedProps }) => (
          <div>
            <IndeterminateCheckbox
              {...getToggleAllRowsSelectedProps()}
              className="overrideCheckbox"
              style={{ display: "flex", justifyItems: "center" }}
              color="white"
            />
          </div>
        ),
        Cell: ({ row }) => (
          <div id="check1">
            <IndeterminateCheckbox
              {...row.getToggleRowSelectedProps()}
              style={{ display: "flex", justifyItems: "center" }}
            />
          </div>
        ),
      });
    }
    return baseColumns;
  }, [tabValue]);
  const columns = columnsOkayGo;

  const handleSearch = () => {
    setFilters((prev) => ({ ...prev, searchBy }));
    setSearchByAuto(searchBy);
  };

  const handleSearchClose = () => {
    setFilters((prev) => ({ ...prev, searchBy: "" }));
    setSearchBy("");
    setSearchByAuto("");
    getPaymentListing(perPage, currentPage, filterUrl);
  };

  const handleActions = (value, mpa_id) => {
    switch (value) {
      case "moreDetails": {
        setMpaId(mpa_id);
        setOpenMpaModal(true);
        break;
      }
      default:
        break;
    }
  };

  const handleUploadActions = (event) => {
    const val = event.target.value;
    switch (val) {
      case "verified": {
        Axios.post(
          `${urlLinks.baseUrl}${urlLinks.mpaListing.updateMpaStatus}?mpaId=${selectedMpaIds}&mpaStatus=VERIFIED`
        ).then((response) => {
          if (response.data.code === 1000) {
            showToast("success", "MPA status updated successfully");
            getPaymentListing(perPage, currentPage);
          } else {
            showToast("error", response.data.response);
          }
        });
        break;
      }
      case "failed": {
        Axios.post(
          `${urlLinks.baseUrl}${urlLinks.mpaListing.updateMpaStatus}?mpaId=${selectedMpaIds}&mpaStatus=FAILED`
        ).then((response) => {
          if (response.data.code === 1000) {
            showToast("success", "MPA status updated successfully");
            getPaymentListing(perPage, currentPage);
          } else {
            showToast("error", response.data.response);
          }
        });
        break;
      }
      case "documentSign": {
        Axios.post(
          `${urlLinks.baseUrl}${urlLinks.mpaListing.updateMpaStatus}?mpaId=${selectedMpaIds}&mpaStatus=DOCUMENT_SIGN`
        ).then((response) => {
          if (response.data.code === 1000) {
            showToast("success", "MPA status updated successfully");
            getPaymentListing(perPage, currentPage);
          } else {
            showToast("error", response.data.response);
          }
        });
        break;
      }
      case "inactive": {
        Axios.post(
          `${urlLinks.baseUrl}${urlLinks.mpaListing.updateMpaStatus}?mpaId=${selectedMpaIds}&mpaStatus=INACTIVE`
        ).then((response) => {
          if (response.data.code === 1000) {
            showToast("success", "MPA status updated successfully");
            getPaymentListing(perPage, currentPage);
          } else {
            showToast("error", response.data.response);
          }
        });
        break;
      }
      case "addMpa": {
        setMpaFormMode("create");
        history.push("/mpaConfig/mpa/add");
        break;
      }
      default:
        break;
    }
    setUploadAction(-1);
  };

  //Function to create table data
  const makeData = (response) => {
    let extractedData = [];
    response.map((el) => {
      extractedData.push({
        is_company: el.is_company || "",
        mpaCode: el.mpaCode || "",
        mpa_id: el.mpa_id || "",
        companyType: el.companyType || "",
        user_id : el.user_id || "",
        pan: el.pan || "",
        gst: el.gst || "",
        designation: el.designation || "",
        mpa_name: el.mpa_name || "",
        panCard: el.panCard?.replace("http://", "https://") || "",
        gstCard: el.gstCard?.replace("http://", "https://") || "",
        client_agreement: el.clientAgreement ? el.clientAgreement.replace("http://", "https://") : "",
        aadharCard: el.aadharCard?.replace("http://", "https://") || "",
        location: el.mpaLocations || "",
        spoc_name: el.spoc_name || "",
        spoc_email_id: el.spoc_email_id || "",
        phone_number: el.phone_number || "",
        email_id: el.spoc_email_id || "",
      });
      return true;
    });
    return extractedData;
  };

  const updateMyData = () => {
    getPaymentListing(perPage, currentPage);
  };

  const getPaymentListing = (rows, pageNo, filterQuery = "") => {
    setLoading(true);
    let requestedBy = "";
    if (localStorage.getItem("roleType")) {
      Axios.get(
        `${urlLinks.baseUrl}${urlLinks.mpaListing.mainListing}?page_no=${
          pageNo - 1
        }${requestedBy}&rows=${rows}&status=${tabValue
          .toLocaleUpperCase()
          .replaceAll(" ", "_")}${filterQuery}${
          searchBy ? `&searchBy=${searchBy}` : ""
        }`
      )
        .then((response) => {
          if (response) {
            setData(makeData(response.data.response));
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  };

  const createAllRecordExcel = () => {
    setAllRecordLoading(true);
    Axios.get(
      `${urlLinks.baseUrl}${urlLinks.mpaListing.mainListing}?status=${tabValue
        .toLocaleUpperCase()
        .replaceAll(" ", "_")}
      `
    )
      .then((response) => {
        if (response.data.code === 1000) {
          setAllRecord(makeAllRecordData(response.data.response) || []);
          setAllRecordLoading(false);
          showToast("success", "MPA list exported successfully");
        } else {
          showToast("error", response.data.response);
        }
      })
      .catch((error) => {
        setAllRecordLoading(false);
        showToast("error", error.response.data.message);
      });
  };

  const uploadDataList =
    tabValue === "Approval in progress"
      ? [
          {
            value: "verified",
            label: "Verified",
          },
          {
            value: "failed",
            label: "Failed",
          },
        ]
      : tabValue === "Verified"
      ? [
          {
            value: "documentSign",
            label: "Document Sign",
          },
        ]
      : tabValue === "Document Sign"
      ? [
          {
            value: "inactive",
            label: "Inactive",
          },
        ]
      : tabValue === "Inactive"
      ? [
          {
            value: "documentSign",
            label: "Document Sign",
          },
        ]
      : [];

  useEffect(() => {
    getPaymentListing(perPage, 1, filterUrl);
  }, [localStorage.getItem("roleType"), tabValue]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: [""],
      },
      updateMyData,
      showToast,
      setLoading,
      manualSortBy: true,
    },
    useFilters,
    useSortBy,
    useRowSelect
  );

  const table = (
    <div className={`tableContainer ${styles.tableContainer}`}>
      <table {...getTableProps()} className="table">
        <thead className="thead">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  className={
                    column.render("Header") === "Worker Id"
                      ? "stickWorkerIdnewMatch zIndex1080 header"
                      : column.render("Header") === "Name"
                      ? "stickWorkerNameMatchNew zIndex1080 header"
                      : "header"
                  }
                >
                  <span {...column.getSortByToggleProps()}>
                    {column.render("Header")}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        {
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} className="row">
                  {row.cells.map((cell) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        className={
                          cell.column.Header === "Worker Id"
                            ? "stickWorkerIdnewMatch  zIndex540"
                            : cell.column.Header === "Name"
                            ? "stickWorkerNameMatchNew zIndex540"
                            : "cell"
                        }
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        }
      </table>
    </div>
  );

  useEffect(() => {
    if (selectedRowIds) {
      const indexes = Object.values(selectedRowIds);
      const indexValues = Object.entries(selectedRowIds);
      indexValues.map((id) => data[parseFloat(id[0])].mpa_id);
      let mpaIdList = [];
      indexValues.map((id) => mpaIdList.push(data[parseFloat(id[0])].mpa_id));
      console.log(mpaIdList.join(","));
      setSelectedMpaIds(mpaIdList.join(","));
      let disableButton = true;
      indexes.map((id) => {
        if (id) {
          disableButton = false;
          return true;
        }
        return true;
      });
      setIsRowSelected(disableButton);
    }
  }, [selectedRowIds]);
  // useEffect(() => {
  //   if (selectedRowIds) {
  //     const indexes = Object.values(selectedRowIds);
  //     let disableButton = true;
  //     indexes.map((id) => {
  //       if (id) {
  //         disableButton = false;
  //         return true;
  //       }
  //       return true;
  //     });
  //     setIsRowSelected(disableButton);

  //     const indexValues = Object.entries(selectedRowIds);
  //     let assignIdList = [];
  //     let userIdList = [];
  //     indexValues.map((id) => {
  //       if (id[1]) {
  //         assignIdList.push(data[parseFloat(id[0])].assignId);
  //         userIdList.push(data[parseFloat(id[0])].userId);
  //       }
  //       return true;
  //     });
  //     assignIdList = assignIdList.join(",");
  //     setSelectedAssignIds(assignIdList);
  //     setSelectedUserIds(userIdList);
  //   }
  // }, [selectedRowIds]);

  const handleFilterApply = () => {
    setIsFilterDrawer(false);
    let query = "";
    if (filters.companyType) query += `&companyType=${filters.companyType}`;
    if (filters.location) query += `&location=${filters.location}`;
    setFilterUrl(query);
    getPaymentListing(perPage, currentPage, query);
  };

  const handleFilterReset = () => {
    setFilters({
      companyType: "",
      location: "",
    });
    setFilterUrl("");
    setIsFilterDrawer(false);
    getPaymentListing(perPage, currentPage, "");
  };

  const loader = (
    <div style={{ margin: "130px auto" }}>
      <ScaleLoader height={70} width={10} color={"#1C4980"} />
    </div>
  );

  return (
    <Styles>
      <Grid container className={styles.pageWrapper}>
        <Grid item xs={12} className={styles.headerRow}>
          MPA List
        </Grid>
        <Grid item xs={12} className={styles.actionBar}>
          <Grid item xs={12} md={6} className={styles.actionBarSearch}>
            <SearchBar
              uniqueId="mpaConfig"
              searchBy={searchBy}
              setSearchBy={setSearchBy}
              searchError={searchError}
              filters={filters}
              setFilters={setFilters}
              handleSearch={handleSearch}
              handleSearchClose={handleSearchClose}
              ApplyFilters={ApplyFilters}
              setFilterUrl={setFilterUrl}
              placeholder="Search by name/ phone number"
              buttonName="Search"
              searchInstructions="Use comma or space as delimiter to search multiple Task ID Max limit 100."
              warningMessage=" Max limit reached. Search 100 pin max."
            />
          </Grid>
          <Grid item xs={12} md={6} className={styles.actionBarControls}>
            {tabValue !== "Failed" && (
              <ActionsDropdown
                uniqueKey="mpaConfig"
                actions={uploadAction}
                handleActions={handleUploadActions}
                actionList={uploadDataList}
                isRowSelected={isRowSelected}
                dropdownName="Update Status"
              />
            )}
            <button
              className={`${styles.filterButton}`}
              onClick={() => setIsFilterDrawer(true)}
            >
              {!(filters.companyType || filters.location) ? (
                <img
                  src={filterIcon}
                  alt="filterIcon"
                  style={{ height: "16px", margin: 0 }}
                />
              ) : (
                <img
                  src={filterIconMarked}
                  alt="filterIconMarked"
                  style={{ height: "16px", margin: 0 }}
                />
              )}
            </button>
            {!!userAction.export_access && (
              <Grid item xs={12} className={styles.exportButton}>
                <div className={styles.exportButtonContainer}>
                  <ExportButton
                    uniqueKey="mpaConfig"
                    createAllRecordExcel={createAllRecordExcel}
                    allRecordLoading={allRecordLoading}
                    filename="MPA List.csv"
                    buttonName="Export to Excel"
                    loadingMessage="Please wait ... it might take few minutes."
                    downloadButton="Download now"
                  />
                </div>
              </Grid>
            )}
          </Grid>

          {/* {!!userAction.edit && (
            <Grid
              style={{
                // marginLeft: "54px",
                display: "flex",
                justifyContent: "end",
              }}
              item
              xs={4}
            >
              <Link to="/mpaConfig/mpa/add" style={{ textDecoration: "none" }}>
                <Button
                  style={{
                    textTransform: "unset",
                    color: "#1C4980",
                    border: "1px solid #1C4980",
                  }}
                  variant="outlined"
                  startIcon={
                    <img
                      alt="/"
                      src={AddIcon}
                      onClick={() => {
                        setMpaFormMode("create");
                      }}
                    />
                  }
                >
                  Add MPA
                </Button>
              </Link>
            </Grid>
          )} */}
        </Grid>

        <Grid item xs={12} className={styles.subNavTabs}>
          <Tabs
            value={tabValue}
            onChange={(e, newIndex) => handleTabChange(e, newIndex)}
            aria-label="mpa status tabs"
            className={`${classes.tabs} ${styles.tabContainer}`}
            textColor="primary"
            indicatorColor="primary"
            TabIndicatorProps={{
              style: { background: "#1C4980" },
            }}
          >
            {tabsData.map((tab, index) => (
              <Tab
                key={index}
                value={tab.value}
                label={tab.label}
                className={styles.tab}
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
        </Grid>
        {loading ? (
          loader
        ) : data.length === 0 ? (
          <div className={styles.noRecord}>
            <img src={NoRecord} alt="noRecord" />
            <span>No records found</span>
          </div>
        ) : (
          <Grid item xs={12} className="paddingTop16">
            {table}
          </Grid>
        )}

        {openMpaModal && mpaId && (
          <TableModal
            uniqueKey="mpaDetails"
            open={openMpaModal}
            setOpen={setOpenMpaModal}
            title="MPA Details"
            url={`${urlLinks.baseUrl}${urlLinks.mpaListing.getMpaDetailByMpaId}${mpaId}`}
          />
        )}

        <Drawer
          anchor="right"
          open={isFilterDrawer}
          onClose={() => setIsFilterDrawer(false)}
        >
          <FilterDrawer
            handleClose={() => setIsFilterDrawer(false)}
            resetFilters={handleFilterReset}
            applyFilters={handleFilterApply}
            filters={filters}
            setFilters={setFilters}
          />
        </Drawer>
      </Grid>
    </Styles>
  );
};
export default MpaConfig;
